<h2 class="sectionTitle"></h2>
<div class="form-container">
  <h4 class="section-title">{{model?.ETendersCategories}}</h4>
</div>
<div class="row" *ngIf="model != null">
 
    <div class="col-md-3 col-md-push-9 col-xs-12">
      <div class="tender-box-holder">
        <!-- <div class="tender-box">
        <button type="button" class="btn btn-primary SCAcustomBtn">Ask a Question</button>
      </div> -->
        <p class="tender-box" *ngIf="model.PrimaryInsuranceValue != null">
          <span class="name">{{'ADMIN_USER.E_TENDER_FORM.PRIMARY_INSURANCE_VALUE'|translate}}</span>
          <span class="price">{{model.PrimaryInsuranceValue}}</span>
        </p>
        <p class="tender-box" *ngIf="model.BookletCopy != ''">
          <a target="_blank" [href]=[model.BookletCopy]>{{'ADMIN_USER.E_TENDER_FORM.BOOKLET'|translate}}</a>
        </p>
      </div>
    </div>
    <div class="col-md-9 col-md-pull-3 col-xs-12">
      <div class="tender-info-holder">
        <div>
          <span class="icon-file" *ngIf="model.FileNumber != null"></span>
          <p>{{'ADMIN_USER.E_TENDER_FORM.FILE_NUMBER'|translate}}</p>
          <p>{{model.FileNumber}}</p>
        </div>
        <div>
          <span class="icon-tenders" *ngIf="model.TenderNumber != null"></span>
          <p>{{'ADMIN_USER.E_TENDER_FORM.TENDER_NUMBER'|translate}}</p>
          <p>{{model.TenderNumber}}</p>
        </div>
        <div>
          <span class="icon-map-pin" *ngIf="model.SessionPlaceAR != null || model.SessionPlaceEN != null"></span>
          <p>{{'ADMIN_USER.E_TENDER_FORM.SESSION_PLACE'|translate}}</p>
          <p>{{model.SessionPlaceAR}}</p>
          <p>{{model.SessionPlaceEN}}</p>
        </div>
        <div>
          <span class="icon-calendar" *ngIf="model.PublishingDate != null"></span>
          <p>{{'ADMIN_USER.E_TENDER_FORM.PUBLISH_DATE'|translate}}</p>
          <p>{{model.PublishingDate}}</p>
        </div>
      </div>
      <div class="tender-body-info">
        <div class="form-container">
          <h4 class="section-title">{{'ADMIN_USER.E_TENDER_FORM.TENDER_CREATION' | translate }}</h4>
        </div>
          <div class="form-container full-width" *ngIf="model.TitleEN != null">
            <div class="form-group">
              <label>{{'ADMIN_USER.E_TENDER_FORM.TITLE_EN' | translate}}</label>
              <p>{{model.TitleEN}}</p>
            </div>
          </div>
          <div class="form-container full-width" *ngIf="model.TitleAR != null">
            <div class="form-group">
              <label>{{'ADMIN_USER.E_TENDER_FORM.TITLE_AR' | translate}}</label>
              <p>{{model.TitleAR}}</p>
            </div>
          </div>
          <div class="form-container">
            <div class="form-group" *ngIf="model.TenderType != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.TENDER_TYPE' | translate}}</label>
              <p>{{model.TenderType}}</p>
            </div>
            <div class="form-group" *ngIf="model.FinancialYear != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.FINANCIAL_YEAR' | translate}}</label>
              <p>{{model.FinancialYear}}</p>
            </div>
            <div class="form-group" *ngIf="model.TenderMethod != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.TENDER_METHOD' | translate}}</label>
              <p>{{model.TenderMethod}}</p>
            </div>
            <div class="form-group" *ngIf="model.HaveMaintenanceContract != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.HAVE_MAINTENANCE_CONTRACT' | translate}}</label>
              <p>{{ model.HaveMaintenanceContract.toString() | translate}}</p>
            </div>
            <div class="form-group" *ngIf="model.MaintenanceContractValue != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.MAINTENANCE_CONTRACT_VALUE' | translate}}</label>
              <p>{{model.MaintenanceContractValue}}</p>
            </div>
            <div class="form-group" *ngIf="model.AcceptRetail != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.MUST_ACCEPT_RETAIL' | translate}}</label>
              <p>{{model.AcceptRetail.toString() | translate}}</p>
            </div>
            <div class="form-group" *ngIf="model.HaveAlternativeOffers != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.ALTERNATIVE_OFFERS_ALLOWED' | translate}}</label>
              <p>{{model.HaveAlternativeOffers.toString() | translate}}</p>
            </div>
            <div class="form-group" *ngIf="model.EvaluationSystem != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.EVALUATION_SYSTEM' | translate}}</label>
              <p>{{model.EvaluationSystem}}</p>
            </div>
            <div class="form-group" *ngIf="model.MinimumAcceptancePointsForTechnicalOffer != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.MINIMUM_ACCEPTANCE_POINTS_FOR_TECHNICAL_OFFER' | translate}}</label>
              <p>{{model.MinimumAcceptancePointsForTechnicalOffer}}</p>
            </div>
          </div>
          <div class="form-container full-width" *ngIf="model.CommentsEN != null">
            <div class="form-group">
              <label>{{'ADMIN_USER.E_TENDER_FORM.ENGLISH_COMMENTS' | translate}}</label>
              <p>{{model.CommentsEN}}</p>
            </div>
          </div>
          <div class="form-container full-width" *ngIf="model.CommentsAR != null">
            <div class="form-group">
              <label>{{'ADMIN_USER.E_TENDER_FORM.ARABIC_COMMENTS' | translate}}</label>
              <p>{{model.CommentsAR}}</p>
            </div>
          </div>
          <div class="form-container">
            <div class="form-group" *ngIf="model.OfferDeadline != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.OFFER_DEADLINE' | translate}}</label>
              <p>{{model.OfferDeadline}}</p>
              <p>{{model.OfferDeadlineTime}}</p>
            </div>
            <div class="form-group" *ngIf="model.ClarificationDurationStartDate != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.CLARIFICATION_DURATION_START_DATE' | translate}}</label>
              <p>{{model.ClarificationDurationStartDate}}</p>
              <p>{{model.ClarificationDurationStartTime}}</p>
            </div>
            <div class="form-group" *ngIf="model.ClarificationDurationEndDate != null">
              <label>{{'ADMIN_USER.E_TENDER_FORM.CLARIFICATION_DURATION_END_DATE' | translate}}</label>
              <p>{{model.ClarificationDurationEndDate}}</p>
              <p>{{model.ClarificationDurationEndTime}}</p>
            </div>
          </div>
            <div class="form-group" *ngIf="model.ETenderSuppliersList != null">
              <label>{{'FRONT_USER.WORKSPACE.SUPPLIERLIST' | translate}}</label>
              <ol  style="-webkit-columns: 3;
              -moz-columns: 3;
              columns: 3;">
                <li *ngFor="let supplier of model.ETenderSuppliersList">
                  {{supplier.CompanyName}}
                </li>
              </ol>
            </div> 
          <form>
          <div class="form-container">
            <div class="form-group" *ngIf="model.ETenderSuppliersList != null">
              <a class="btn btn-primary SCAcustomBtn" href="mailto:?bcc={{supplierEmailList}}&subject={{model.TitleEN || model.TitleAR}}">
                Contact Via Email
              </a>
            </div>  
          </div>
        </form>
    </div>
  
</div>
<div class="row" *ngIf="model != null">
  <!--Messaging-->
<app-messaging *ngIf="!isAdmin && isSupplierAvailabale" MessagingBoxTitle="Clarifications" isMessageBoxDisabled="{{!(model?.ShowClarification)}}"></app-messaging>

<app-messaging *ngIf="isAdmin && isSupplierAvailabale" MessagingBoxTitle="Clarifications"></app-messaging>

<app-messaging *ngIf="isAdmin && !isSupplierAvailabale" MessagingBoxTitle="GeneralMessages"></app-messaging>
</div>